import {Fragment} from 'react'
import PropTypes from 'prop-types'

import './CardCol.scss'
export default function CardCol({children, className, flex, basis, grow, align, alignSelf, shrink, style, txt, ...props}) {
  const handleStyle = () => {
    const styleAttr = (style)? style : {}

    return {
      ...((align)? {textAlign: align}: {}),
      ...((alignSelf)? {alignSelf: alignSelf}: {}),
      ...((flex)? {flex: flex}: {}),
      ...((basis)? {flexBasis: basis}: {}),
      ...((grow)? {flexGrow: grow}: {}),
      ...((shrink)? {flexShrink: shrink}: {}),
      ...styleAttr,
    }
  }

  return (
    <div className={`tw-card-col ${className ? className : ''}`}  {...props} style={handleStyle()}>
      {txt? <Fragment>{txt}</Fragment> : null}
      {children}
    </div>)
}

CardCol.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  align: PropTypes.string,
  alignSelf: PropTypes.string,
  flex: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  basis: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  grow: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  shrink: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  txt: PropTypes.string,
  className: PropTypes.string
}